// extracted by mini-css-extract-plugin
export default {"section":"BannerTopSection_section__LEB5l","bannerOurValues":"BannerTopSection_bannerOurValues__qZ180"};